import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-22cbdb32"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "widget-calendar-day" }
const _hoisted_2 = { class: "widget-calendar-day__content" }
const _hoisted_3 = { class: "widget-calendar-day__content__slots" }

import { PropType } from 'vue'
import { MinimumTimeslot } from '@/models/public/service.model'
import { differenceInMinutes } from 'date-fns'
import isSameDay from 'date-fns/isSameDay'
import startOfDay from 'date-fns/startOfDay'
import WidgetSlot from '@/components/booking-widget/WidgetSlot.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'WidgetDay',
  props: {
  day: {
    type: Date,
    required: true,
  },
  slots: {
    type: Array as PropType<MinimumTimeslot[]>,
    default: () => [],
  },
  selectedSlots: {
    type: Array as PropType<MinimumTimeslot[]>,
    default: () => [],
  },
  timeSlots: {
    type: Array as PropType<number[]>,
    required: true,
  },
  withLabels: {
    type: Boolean,
    default: false,
  },
  slotId: {
    type: Number,
    default: undefined,
  },
},
  emits: ['onClick'],
  setup(__props, { emit: emits }) {

const props = __props





const findSlotForTime = (minutes: number) =>
  props.slots.find((slot: MinimumTimeslot) => {
    if (props.slotId && slot.id !== props.slotId) {
      return false
    }
    const slotStartMinutes = differenceInMinutes(
      new Date(slot.start),
      startOfDay(new Date(slot.start)),
    )
    const slotEndMinutes = differenceInMinutes(
      new Date(slot.end),
      startOfDay(new Date(slot.start)),
    )
    return (
      isSameDay(new Date(slot.start), props.day) &&
      slotStartMinutes <= minutes &&
      minutes < slotEndMinutes
    )
  })

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.timeSlots, (timeSlot) => {
          return (_openBlock(), _createBlock(WidgetSlot, {
            key: timeSlot,
            "widget-slot": findSlotForTime(timeSlot),
            "selected-slots": __props.selectedSlots,
            onOnClick: _cache[0] || (_cache[0] = (value) => emits('onClick', value))
          }, null, 8, ["widget-slot", "selected-slots"]))
        }), 128))
      ])
    ])
  ]))
}
}

})